import React from 'react';
import { BookOpen } from 'lucide-react';
import type { PortalClass } from '../types/portal';

interface Props {
  cls: PortalClass;
  size?: number;
  width?: number;
  height?: number;
  rounded?: string;
  className?: string;
}

const CourseCover: React.FC<Props> = ({
  cls,
  size = 88,
  width,
  height,
  rounded = 'rounded-2xl',
  className = '',
}) => {
  const w = width ?? size;
  const h = height ?? size;

  if (cls.cover_image_url) {
    return (
      <img
        src={cls.cover_image_url}
        alt={cls.title}
        className={`${rounded} object-cover shrink-0 ${className}`}
        style={{ width: w, height: h }}
      />
    );
  }

  const label = cls.level ?? cls.category ?? cls.title.substring(0, 2).toUpperCase();

  return (
    <div
      className={`${rounded} shrink-0 relative overflow-hidden flex flex-col items-center justify-center border border-[#eadfd6] dark:border-neutral-700 bg-gradient-to-br from-white to-[#faf7f5] dark:from-neutral-800 dark:to-neutral-900 ${className}`}
      style={{ width: w, height: h }}
    >
      <div className="absolute top-0 left-0 right-0 h-0.5 bg-gradient-to-r from-[#970000]/0 via-[#970000]/60 to-[#970000]/0" />
      <BookOpen className="h-5 w-5 text-[#970000]/70 dark:text-red-400/70 mb-1" />
      <span className="text-[#111827] dark:text-neutral-200 font-bold text-xs text-center leading-tight px-1 tracking-wide">
        {label}
      </span>
    </div>
  );
};

export default CourseCover;
